export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-slate-50">
      <div className="relative max-w-7xl mx-auto px-6 md:px-8 py-20 md:py-28 grid md:grid-cols-2 gap-12 items-center">
        {/* TEXT */}
        <div className="text-center md:text-left">
          <h1 className="mt-4 text-3xl md:text-5xl font-bold text-slate-900 leading-tight">
            Find Your Next{" "}
            <span className="text-orange-500">Comfortable Home</span>
          </h1>

          <p className="mt-6 text-slate-600 text-base md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
            Affordable rental units designed for comfort, safety, and everyday
            living. Perfect for students, professionals, and long-term tenants.
          </p>

          {/* CTA BUTTONS */}
          <div className="mt-8 flex flex-col sm:flex-row justify-center md:justify-start gap-4">
            <button className="bg-orange-500 text-white px-7 py-3 rounded-md font-semibold hover:bg-orange-600 transition shadow-lg shadow-orange-500/20">
              View Available Units
            </button>

            <button className="bg-white text-slate-700 px-7 py-3 rounded-md font-semibold border border-slate-200 hover:border-orange-500 hover:text-orange-500 transition">
              Contact Us
            </button>
          </div>

          {/* MINI FEATURES */}
          <div className="mt-10 grid grid-cols-3 gap-4 max-w-md mx-auto md:mx-0">
            <div>
              <h3 className="text-xl font-bold text-slate-900">24/7</h3>
              <p className="text-sm text-slate-500">Security</p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-slate-900">Fast</h3>
              <p className="text-sm text-slate-500">WiFi</p>
            </div>

            <div>
              <h3 className="text-xl font-bold text-slate-900">Clean</h3>
              <p className="text-sm text-slate-500">Rooms</p>
            </div>
          </div>
        </div>

        {/* IMAGE */}
        <div className="relative">
          <img
            src="https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1920&q=80"
            className="rounded-2xl shadow-2xl w-full h-80 md:h-120 object-cover"
            alt="Rental unit"
          />

          {/* FLOATING CARD */}
          <div className="absolute left-4 right-4 bottom-4 md:left-6 md:right-auto md:w-72 bg-white/95 backdrop-blur rounded-xl p-5 shadow-xl">
            <p className="text-sm text-slate-500">Starting from</p>

            <h3 className="text-2xl font-bold text-slate-900 mt-1">
              ₱5,000
              <span className="text-sm font-medium text-slate-500">
                {" "}
                / month
              </span>
            </h3>

            <p className="text-sm text-slate-600 mt-2">
              Safe, quiet, and convenient rental units.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
